async function expectOk(response, label) {
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  }
  const detail = response.data?.message || response.data?.error || JSON.stringify(response.data);
  throw new Error(`${label} failed (${response.status}): ${detail}`);
}

export { expectOk };
